<template>
    <div id="emailModal" class="modal fade" ref="emailModal" tabindex="-1" role="dialog">
        <div v-blur="loading" class="modal-dialog modal-lg" role="document" id="emailModalContent">
            <div class="row subject">
                <div class="subject-and-date">
                    <p>
                        Subject: {{emailSubject}}
                    </p>
                    <p>
                        Email Date: {{email_date}}
                    </p>
                </div>
                <div class="ip-domain-email">
                    <p>Sender IP/Domain: {{sender_ip_domain}}</p>
                    <p>Recipient Domain: {{recipient_domain}}</p>
                    <p>Recipient Email: {{recipient_email}}</p>
                </div>
            </div>
            <div v-html="emailHtml" class="row email-content"></div>
            <div class="row actions">
                <button class="btn download-button" @click="downloadEmail">Download</button>
                <button class="btn cancel-button" @click="closeClicked">Close</button>
            </div>
        </div>
        <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
    </div>
</template>

<script>

    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import Constants from '@/utils/constants'
    import 'setimmediate';
    import Common from '@/utils/Common.vue'

    export default {
        name: "email-display-modal",
        data() {
            return {
                emailHtml: null,
                emailSubject: null,
                sourceUrl: null,
                isOpen: false,
                loading: false,
                page: '',
                mail_content: '',
                partner_id: null,
                email_date: null,
                sender_ip_domain: null,
                recipient_domain: null,
                recipient_email: null
            }
        },
        components: {
            LoadingModal: LoadingModal
        },
        mixins: [Common],
        methods: {
            showModal(emailUrl, emailSubject, page, mail_content, partner_id, email_date, sender_ip_domain, recipient_domain, recipient_email) {
                this.emailHtml = null;
                this.emailSubject = null;
                this.$nextTick(function () {
                    $('#emailModal').modal('show');
                    this.emailSubject = emailSubject;
                    this.isOpen = true;
                    this.sourceUrl = emailUrl;
                    this.loading = true;
                    this.page = page;
                    this.mail_content = mail_content;
                    this.partner_id = partner_id;
                    this.email_date = email_date;
                    this.sender_ip_domain = sender_ip_domain;
                    this.recipient_domain = recipient_domain;
                    this.recipient_email = recipient_email;
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/file/getemlcontent', {
                        url: emailUrl
                    })
                        .then(response => {

                            const simpleParser = require('mailparser').simpleParser;
                            var self = this;
                            simpleParser(response.body.html).then(mail => {
                                self.emailHtml = mail.html;
                                self.emailSubject = mail.subject;
                            }).catch(err => {
                                self.$toasted.show('E-mail parser error, please try again.', {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            });

                            this.loading = false;
                        }, response => { //ERROR
                            this.$toasted.show('Server error during getting e-mail content, please try again.', {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            this.loading = false;
                        })
                });
            },
            downloadEmail: function () {
                if (this.sourceUrl) {
                    this.saveLog(this, this.page, 'Eml Downloaded (Mail url: ' + this.mail_content + ')', null, this.partner_id);
                    this.downloadFileWithBackend(this.emailSubject, this.sourceUrl, 'eml');
                } else {
                    this.$toasted.show('Server error during getting e-mail content, please try again.', {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            closeClicked: function () {
                $('#emailModal').modal('hide');
            }
        }
    }
</script>

<style scoped>

    .subject p {
        font-size: 14px;
    }

    .subject-and-date {
        width: 50%;
    }

    #emailModal {
        position: absolute;
    }

    .loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

    #emailModalContent {
        width: 80% !important;
    }

    .cancel-button {
        font-family: 'Digital-Serial-Bold';
        background-color: rgba(0, 255, 169, 1);
        color: rgba(52, 63, 73, 1);
        width: 125px;
        height: 40px;
        margin: 5px;
        font-size: 14px;
        border: none;
    }

    .download-button {
        width: 125px;
        height: 40px;
        background-color: rgba(255, 0, 67, 1);
        color: white;
        font-family: 'Digital-Serial-Bold';
        margin: 5px;
        font-size: 14px;
        border: none;
    }

    .email-content {
        overflow: auto;
        background-color: white;
    }

    .actions {
        background-color: rgb(17, 21, 26);
        color: white;
        font-family: 'Digital-Serial-Bold';
        text-align: right;
    }

    .subject {
        background-color: rgb(17, 21, 26);
        color: white;
        font-family: 'Digital-Serial-Bold';
        line-height: 30px;
        font-size: 24px;
        padding-left: 20px;
        display: flex;
        flex-direction: row;
    }

    @-webkit-keyframes zoom {
        from {
            -webkit-transform: scale(0)
        }
        to {
            -webkit-transform: scale(1)
        }
    }

    @keyframes zoom {
        from {
            transform: scale(0)
        }
        to {
            transform: scale(1)
        }
    }

    @media only screen and (max-width: 700px) {
        .my-modal-content {
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/EmailDisplayModal.vue